import React from 'react';
import { useSelector } from 'react-redux';
import { currentUserSelector } from '../../../../ducks/user.duck';
import { cartCountSelector } from '../../../CartPage/CartPage.duck';
import { NamedLink } from '../../../../components';
import css from './CartLink.module.css';
import { getUserCartDetails } from '../../../../util/userDataExtractor';
import Icons from '../../../../components/Icons/Icons';
const CartLink = () => {
  const currentUser = useSelector(currentUserSelector);
  const cartCount = useSelector(cartCountSelector);
  const cartDetails = getUserCartDetails(currentUser);
  const itemCount = cartDetails?.length;
  return (
    <NamedLink className={css.topbarLink} name="CartPage">
      <div className={css.cartIconWrapper}>
        <Icons name="bagEmpty" className={css.cartIcon} />
        {(itemCount || cartCount) > 0 && (
          <span className={css.badge}>{itemCount ?? cartCount}</span>
        )}
      </div>
    </NamedLink>
  );
};

export default CartLink;
